export const UPDATE_CONFIG_ENV = "UPDATE_CONFIG_ENV";
export const UPDATE_CONFIG_TOKEN = "UPDATE_CONFIG_TOKEN";
export const UPDATE_CONFIG_REMOTE = "UPDATE_CONFIG_REMOTE";
export const UPDATE_CONFIG_MODE = "UPDATE_CONFIG_MODE";
export const UPDATE_CONFIG_EXTRA = "UPDATE_CONFIG_EXTRA";
